import { render, staticRenderFns } from "./LffProject.vue?vue&type=template&id=2b98c958&scoped=true&"
import script from "./LffProject.vue?vue&type=script&lang=js&"
export * from "./LffProject.vue?vue&type=script&lang=js&"
import style0 from "./LffProject.vue?vue&type=style&index=0&id=2b98c958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98c958",
  null
  
)

export default component.exports